import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _container;
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import React from 'react';
import cn from 'classnames';
function ListItemWrapper(_ref) {
  var Component = _ref.as,
    children = _ref.children,
    selected = _ref.selected,
    disabled = _ref.disabled,
    focused = _ref.focused,
    size = _ref.size,
    className = _ref.className,
    onMouseOver = _ref.onMouseOver;
  var childCount = React.Children.count(children);
  if (!childCount) {
    return null;
  }
  return jsx(Component, {
    sx: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles.container), styles.container[size]), selected && styles.container.selected), focused && styles.container.focused), disabled && styles.container.disabled),
    className: cn('zenit', className),
    onMouseOver: onMouseOver
  }, childCount === 1 && React.Children.map(children, function (child) {
    if (!child) {
      return null;
    }
    return /*#__PURE__*/React.cloneElement(child, {
      sx: styles.child
    });
  }), childCount > 1 && children);
}
ListItemWrapper.SIZES = {
  medium: 'medium',
  large: 'large'
};
var hoverStyles = {
  backgroundColor: 'var(--colors-grey-cool-10)'
};
var styles = {
  container: (_container = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: 'grey.0',
    border: '1px solid',
    borderColor: 'transparent',
    borderBottomColor: 'grey.6'
  }, _defineProperty(_container, ListItemWrapper.SIZES.medium, {
    height: '36px'
  }), _defineProperty(_container, ListItemWrapper.SIZES.large, {
    height: '52px'
  }), _defineProperty(_container, '&:hover', hoverStyles), _defineProperty(_container, '&:active', {
    backgroundColor: 'grey.4'
  }), _defineProperty(_container, '&:focus', {
    borderColor: 'var(--colors-whitelabel-button-primary-background-active)'
  }), _defineProperty(_container, "selected", {
    backgroundColor: 'grey.4'
  }), _defineProperty(_container, "focused", hoverStyles), _defineProperty(_container, "disabled", {
    backgroundColor: 'grey.0',
    '&:hover': {},
    '&:active': {},
    '&:focus': {}
  }), _container),
  child: {
    height: '100%',
    paddingX: 3
  }
};
ListItemWrapper.defaultProps = {
  as: 'div',
  disabled: false,
  selected: false,
  focused: false,
  size: ListItemWrapper.SIZES.medium
};
export { ListItemWrapper };